import styled from "styled-components";
import {SideMenuItemsContainerDefaultBox} from "./side-menu-item-container.default.box";

export const SideMenuItemsListCasino888Box = styled(SideMenuItemsContainerDefaultBox)`
    margin: 0;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0;
    }
    
    &::before {
        display: none;
    }
`;
